<template>
  <div class="con">
    <div class="container pt-[20vh]">
      <a-result status="404" title="404" sub-title="很抱歉，您访问的页面不存在。">
        <template #extra>
          <a-button type="primary" @click="backHome">返回首页</a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>
<script setup>
function backHome() {
  window.location.href = "/";
}
</script>

<style scoped lang="scss"></style>
